export default "__VITE_ASSET__ByZOVQcZ__"